import { redirectForCalendarConsent, useAppDispatch, withAsyncThunkErrorHandling } from "@lib/store";
import { useIsTeamsApp, useTeamsMeetConsent } from "@hooks";

/** Starts connecting the user's calendar: Teams asks for consent in a popup, the browser redirects to the provider. */
export const useConnectCalendar = () => {
  const dispatch = useAppDispatch();
  const isTeamsApp = useIsTeamsApp();
  const { askForConsent } = useTeamsMeetConsent();

  const connectCalendar = () => {
    if (isTeamsApp) {
      askForConsent();
      return;
    }

    dispatch(withAsyncThunkErrorHandling(() => redirectForCalendarConsent()));
  };

  return connectCalendar;
};
